import React from 'react';
import PropTypes from 'prop-types';

WmsCarrierIcon.propTypes = {
    iconName: PropTypes.string,
    altName: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    style: PropTypes.object,
};

function WmsCarrierIcon({iconName, altName, width = null, height = null, style = {}}) {
    if (!iconName) {
        return null;
    }

    try {
        return (
            <img
                style={{
                    width: width,
                    height: height,
                    ...style
                }}
                src={require(`../../assets/img/carrier-icons/${iconName}.svg`)}
                alt={`${altName} icon`}
            />
        )
    } catch (e) {
        return null;
    }
}

export default WmsCarrierIcon;
